module.exports = __webpack_public_path__ + "img/goya.75682aae.svg";